import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function TaskBanner({
  label,
  prompt,
  running = false,
  error = null,
  completed = false,
}) {
  if (!prompt) return null;

  const Icon = error ? XCircle : running ? Loader2 : CheckCircle2;
  const title = error
    ? `Could not finish in ${label}`
    : running
    ? `Working in ${label}…`
    : completed
    ? `Finished in ${label}`
    : `Starting ${label}…`;

  return (
    <div
      className={`mx-4 md:mx-10 mt-3 mb-1 text-xs rounded-lg border px-3 py-2.5 flex items-start gap-2 ${
        error
          ? "border-red-500/30 bg-red-500/10"
          : running
          ? "border-consensus-500/25 bg-consensus-500/10"
          : completed
          ? "border-emerald-500/25 bg-emerald-500/10"
          : "border-white/10 bg-white/5"
      }`}
    >
      <Icon
        className={`h-4 w-4 shrink-0 mt-0.5 ${
          error
            ? "text-red-300"
            : running
            ? "animate-spin text-consensus-300"
            : completed
            ? "text-emerald-300"
            : "text-white/40"
        }`}
      />
      <div className="min-w-0">
        <p
          className={`font-medium ${
            error
              ? "text-red-200"
              : running
              ? "text-consensus-200"
              : completed
              ? "text-emerald-200"
              : "text-white/70"
          }`}
        >
          {title}
        </p>
        <p className="text-white/50 mt-0.5 truncate">{prompt}</p>
        {error && <p className="text-red-300/80 mt-1">{error}</p>}
      </div>
    </div>
  );
}
